let creditTypeOptions = [
  {
    label: '主体授信',
    value: '主体授信'
  },
  {
    label: '资产授信',
    value: '资产授信'
  }
]

export default creditTypeOptions



// WEBPACK FOOTER //
// ./src/utils/creditTypeOptions.js